// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".plv-icon{font-family:plv-admin-icon!important}\n", "",{"version":3,"sources":["webpack://./node_modules/@polyv/polyv-ui/lib-admin/theme/icon.css"],"names":[],"mappings":"AAAA,UAAU,oCAAoC","sourcesContent":[".plv-icon{font-family:plv-admin-icon!important}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
